import { ItineraryEvent } from "@/types/itinerary"
import { createAsyncThunk } from "@reduxjs/toolkit"

import { toastManager } from "@/lib/toast"
import { streamedItineraryEventToastLeading } from "@/lib/toast-leading"
import { selectDetailSheetOpen } from "./detail-sheet-slice"
import inspirationSlice, {
  selectIsGenerateInspirationAfterStream,
} from "./inspiration-slice"
import { AppDispatch, RootState } from "./redux-store"

export const showToastsForStreamedEvents = createAsyncThunk<
  void,
  {
    events: ItineraryEvent[]
  },
  {
    dispatch: AppDispatch
    state: RootState
  }
>(
  "streamingThunks/showToastsForStreamedEvents",
  async ({ events }, { dispatch, getState }) => {
    events.forEach(async (event) => {
      if (selectDetailSheetOpen(getState())) return

      // If we are generating inspiration, we don't to say "... added to trip".  Instead "... added to your guide"
      const isGeneratingInspiration =
        selectIsGenerateInspirationAfterStream(getState())
      if (isGeneratingInspiration) {
        dispatch(inspirationSlice.actions.setGenerateInspirationState("start"))
      }

      const photoUrl = event.place?.photos?.[0]?.url
      const leading = streamedItineraryEventToastLeading({
        eventType: event.type,
        photoUrl,
        title: event.title,
      })

      toastManager.add({
        description: `${event.title} added to your ${
          isGeneratingInspiration ? "guide" : "trip"
        }`,
        data: { leading },
      })
    })
  }
)
